import { render } from "./VideoPlayer.vue?vue&type=template&id=6a7e6a2c&scoped=true"
import script from "./VideoPlayer.vue?vue&type=script&lang=ts"
export * from "./VideoPlayer.vue?vue&type=script&lang=ts"

import "./VideoPlayer.vue?vue&type=style&index=0&id=6a7e6a2c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6a7e6a2c"

export default script